<template>
  <urne />
</template>

<script>
import Urne from '../components/KeuzesUitvaart/Urne.vue'

export default {
  name: 'UrneView',
  components: {
    Urne
  }
}
</script>
